import { Helmet } from "react-helmet-async";
import { Service_CN } from "../../utils/CommonFunc";
import { useRecoilValue } from "recoil";
import { t } from "i18next";
import { langCodeState } from "../../recoil/commonUiAtom";

function LoungeHelmet(props: { title: string }) {
  const langCode = useRecoilValue(langCodeState);

  return (
    <Helmet htmlAttributes={{ lang: `${langCode}` }}>
      <title>
        {Service_CN ? props.title : props.title + " - " + t("vfun_lounge")}
      </title>
      {Service_CN ? (
        <link rel="icon" href="/favicon-cn.ico" />
      ) : (
        <link rel="icon" href="/favicon-gl.ico" />
      )}
    </Helmet>
  );
}

export default LoungeHelmet;
